<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">GRAFICOS POR PARAMETROS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="2" sm="2">
                        <date-picker v-model="fecha_inicio" @change="cargarDatos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <date-picker v-model="fecha_termino" @change="cargarDatos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-select
                            v-model="punto_medicion"
                            :items="puntos_medicion"
                            item-text="nombre_punto"
                            item-value="id"
                            label="Punto de Medición"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarEquipos">
                        </v-select>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-select
                            v-model="equipo"
                            :items="equipos"
                            item-text="nombre_equipo"
                            item-value="id"
                            label="Equipo"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarParametros">
                        </v-select>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-select
                            v-model="parametro"
                            :items="parametros"
                            item-text="nombre_parametro"
                            item-value="id"
                            label="Parámetro"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarDatos">
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-btn @click="download" outlined color="green">Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-text>
                <GChart
                    type="LineChart"
                    :data="chartData"
                    :options="chartOptions"
                    @ready="onChartReady"
                />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import {mapState,mapMutations} from 'vuex'
    //import Tabla from '@/components/shared/Tabla.vue'
    import Data_Table from '@/components/shared/Data_Table.vue'
    import Modal from '@/components/shared/Modal.vue'
    import { GChart } from 'vue-google-charts'
    //datepicker vue2
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/es';
    import ModalAyudas from '@/components/shared/ModalAyudas.vue';
    // import axios from 'axios'
    export default {
        data:()=>({
            punto_medicion: {},
            puntos_medicion: [],
            equipos: [],
            equipo: {},
            parametros: [],
            parametro: {},
            fecha_inicio: new Date().toISOString().substr(0, 10),
            fecha_termino: new Date().toISOString().substr(0, 10),
            mostrar_fecha1: false,
            mostrar_fecha2: false,
            url_excel: '',
            show_excel: false,
            chartData: [],
            chartOptions: {
                title: '',
                subtitle: '',
                legend: 'bottom',
                pointSize: 5,
                intervals: { style: 'columns' },
                curveType: 'function',
            },
        }),
        created() {
            
        },
        mounted() {
            this.cargarPuntos();
        },
        methods: {
            abrirAyudas() {
                const jiji = [
                    {   titulo:`Ayuda de Gráficos por Parámetros`,    tipo:`titulo`},
                    {   tipo:`label`,   texto:`En esta pantalla se muestra un gráfico de línea de los promedios de los parámetros según las fechas, punto de medición, equipo y parámetro indicados.`},
                    {   tipo:`label`,   texto:`- Los primeros dos campos son para seleccionar el rango de fechas en el que se quiere obtener el gráfico. El tercero se indica el punto de medición, el siguiente el equipo y el último el parámetro del que se quiere obtener un gráfico con los promedios.`},
                    {   tipo:`label`,   texto:`- Al pulsar el botón "Excel", se exportará toda la información mostrada según la fecha indicada en formato Excel.`},
                ];
                
                Event.$emit('mostrar_alert',jiji);
            },
            onChartReady (chart, google) {
                // now we have google lib loaded. Let's create data table based using it.
                this.createDataTable(google)
            },
            createDataTable(google) {
                const data = new google.visualization.DataTable();
                data.addColumn('number', 'x');
                data.addColumn('number', 'values');
                /*
                data.addColumn({id:'i0', type:'number', role:'interval'});
                data.addColumn({id:'i1', type:'number', role:'interval'});
                data.addColumn({id:'i2', type:'number', role:'interval'});
                data.addColumn({id:'i2', type:'number', role:'interval'});
                data.addColumn({id:'i2', type:'number', role:'interval'});
                data.addColumn({id:'i2', type:'number', role:'interval'});
            
                data.addRows([
                [1, 100, 90, 110, 85, 96, 104, 120],
                [2, 120, 95, 130, 90, 113, 124, 140],
                [3, 130, 105, 140, 100, 117, 133, 139],
                [4, 90, 85, 95, 85, 88, 92, 95],
                [5, 70, 74, 63, 67, 69, 70, 72],
                [6, 30, 39, 22, 21, 28, 34, 40],
                [7, 80, 77, 83, 70, 77, 85, 90],
                [8, 100, 90, 110, 85, 95, 102, 110]]);
                */
                // Since the :data is reactive, we just need to update it's value
                this.chartData = data;
            },
            async cargarPuntos(){
                let url = `${this.base_url}punto_medicion`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.puntos_medicion = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarEquipos(){
                let url = `${this.base_url}punto_medicion/equipos/${this.punto_medicion.id}`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.equipos = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarParametros(){
                let url = `${this.base_url}punto_medicion/parametros/${this.punto_medicion.id}/${this.equipo.id}`;
                await this.axios.get(url, this.headers).then((response)=>{
                    this.parametros = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            async cargarDatos(){
                this.chartOptions.title = "Grafico de "+this.parametro.nombre_parametro;
                this.chartOptions.legend = "bottom";
                this.chartData = [];
                this.url_excel = '';
                //this.mostrarLoading('Cargando Datos...');
                this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

                let url = `${this.base_url}resultados/grafico_parametros/${this.parametro.id}/${this.fecha_inicio}/${this.fecha_termino}`;
                await this.axios.get(url,this.headers).then((response)=>{
                    let datos = response.data.data;
                    this.chartData.push(['Día', 'Promedio '+this.parametro.nombre_parametro + ' diario']);
                    datos.grafico.forEach(result => {
                        this.chartData.push([result.fecha, parseFloat(result.valor)]);
                    });
                    this.url_excel = datos.url_excel;
                    this.ocultarLoading();
                }).catch((error)=>{
                    console.log(error);
                    this.ocultarLoading();
                })
            },
            download(){
                window.location.href = this.url_excel;
            },

            ...mapMutations(['mostrarLoading','ocultarLoading'])
        },
        computed: {
            ...mapState(['base_url','headers']),

            fecha_formateada1 () {
                return this.fecha_inicio ? this.moment(this.fecha_inicio).format('DD-MM-YYYY') : '';
            },

            fecha_formateada2 () {
                return this.fecha_termino ? this.moment(this.fecha_termino).format('DD-MM-YYYY') : '';
            }
        },
        components:{
            'modal':Modal,
            'data-table':Data_Table,
            GChart,
            DatePicker,
            'modal-ayuda': ModalAyudas,
        }
    }
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
        margin-top: 18px;
    }
</style>